import React from "react"

const ZoomIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.8 9.5L5.65 6.35C5.4 6.55 5.1125 6.70833 4.7875 6.825C4.4625 6.94167 4.11667 7 3.75 7C2.84167 7 2.07292 6.68542 1.44375 6.05625C0.814583 5.42708 0.5 4.65833 0.5 3.75C0.5 2.84167 0.814583 2.07292 1.44375 1.44375C2.07292 0.814583 2.84167 0.5 3.75 0.5C4.65833 0.5 5.42708 0.814583 6.05625 1.44375C6.68542 2.07292 7 2.84167 7 3.75C7 4.11667 6.94167 4.4625 6.825 4.7875C6.70833 5.1125 6.55 5.4 6.35 5.65L9.5 8.8L8.8 9.5ZM3.75 6C4.375 6 4.90625 5.78125 5.34375 5.34375C5.78125 4.90625 6 4.375 6 3.75C6 3.125 5.78125 2.59375 5.34375 2.15625C4.90625 1.71875 4.375 1.5 3.75 1.5C3.125 1.5 2.59375 1.71875 2.15625 2.15625C1.71875 2.59375 1.5 3.125 1.5 3.75C1.5 4.375 1.71875 4.90625 2.15625 5.34375C2.59375 5.78125 3.125 6 3.75 6ZM3.25 5.25V4.25H2.25V3.25H3.25V2.25H4.25V3.25H5.25V4.25H4.25V5.25H3.25Z"
        fill="currentColor"
      />
    </svg>
  )
}

export { ZoomIcon }
